import { computed, nextTick, ref, watch, WatchStopHandle } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import { NotificationStatuses } from '@/models/notifications.interface';
import campaignReadinessPresenter from '@/presenters/campaign-readiness-presenter';
import store from '@/store';

export default class TitleBlockCode {
	public latestSavedName = ref('');
	private unwatchForLoadingFlag: WatchStopHandle | null = null;
	private unwatchForNotificationStatus: WatchStopHandle | null = null;

	private name = computed((): string => {
		return store.getters.name();
	});

	private notificationStatus = computed((): NotificationStatuses => {
		return store.getters.notificationStatus();
	});

	public isPrimaryDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isCampaignReadinessInfoLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusCampaignReadinessInfo();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public campaignIssuesAsSentences = computed((): string[] => {
		return campaignReadinessPresenter.campaignIssuesAsSentences.value;
	});

	public isCampaignValid = computed((): boolean => {
		return campaignReadinessPresenter.isCampaignValid.value;
	});

	public isCampaignInvalid = computed((): boolean => {
		return campaignReadinessPresenter.isCampaignInvalid.value;
	});

	public mounted(): void {
		this.unwatchForLoadingFlag = watch(this.isPrimaryDataLoading, this.updateLatestSavedName.bind(this));
		this.unwatchForNotificationStatus = watch(this.notificationStatus, this.updateLatestSaveNameOnSuccessfulSave.bind(this));
		void this.updateLatestSavedName();
	}

	public unmounted(): void {
		if (this.unwatchForLoadingFlag) {
			this.unwatchForLoadingFlag();
		}
		if (this.unwatchForNotificationStatus) {
			this.unwatchForNotificationStatus();
		}
	}

	private updateLatestSaveNameOnSuccessfulSave(notificationStatus: NotificationStatuses): void {
		if (notificationStatus !== NotificationStatuses.SAVING_SUCCESS) {
			return;
		}

		void this.updateLatestSavedName();
	}

	private async updateLatestSavedName(): Promise<void> {
		if (this.isPrimaryDataLoading.value) {
			return;
		}

		await nextTick();

		this.latestSavedName.value = this.name.value;
	}
}
